export default "__VITE_ASSET__CORLuRvH__"